var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.obj_to_null(this.cur_item)
    ? _c("div", { staticClass: "categ_info" }, [
        !_vm.is_set_data
          ? _c(
              "div",
              { staticClass: "redraw_block" },
              [
                _c("info_field", {
                  attrs: {
                    f_uniq: "ct3",
                    f_type: "group_name",
                    is_disabled: true,
                    f_title: _vm.__t("ROLE.GROUP"),
                    f_val: _vm.active_group_title,
                  },
                }),
                _vm._v(" "),
                _c("info_field", {
                  attrs: {
                    f_uniq: "ct355",
                    f_type: "pin",
                    is_disabled: true,
                    f_title: _vm.__t("PIN"),
                    f_val: _vm.cur_item.pin,
                  },
                }),
                _vm._v(" "),
                _c("info_field", {
                  attrs: {
                    f_uniq: "ct1",
                    f_type: "title",
                    is_disabled: false,
                    f_title: _vm.__t("NAME"),
                    f_val: _vm.cur_item.title,
                  },
                  on: { update_categ: _vm.change_atr },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "allow_in" },
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", [
                          _c(
                            "div",
                            [
                              _c("yes_no", {
                                key: "PUBLISHED",
                                attrs: { title: "PUBLISHED" },
                                on: {
                                  input: function (val) {
                                    return _vm.change_atr("published", val)
                                  },
                                },
                                model: {
                                  value: _vm.cur_item.published,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cur_item, "published", $$v)
                                  },
                                  expression: "cur_item.published",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }